import { render } from "./ModalButton.vue?vue&type=template&id=748aa084"
import script from "./ModalButton.vue?vue&type=script&lang=js"
export * from "./ModalButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__